<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <GiftForm
          v-model="gift"
          title="Editace dárku"
          :edit="true"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import GiftForm from '@/components/forms/GiftForm'

export default {
  name: 'GiftEdit',
  components: {
    GiftForm,
  },
  data() {
    return {
      gift: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadGift()
  },
  methods: {
    ...mapActions({
      getGift: 'gift/getGift',
      updateGift: 'gift/updateGift',
    }),
    loadGift() {
      this.loading = true
      this.getGift(this.$route.params.giftId)
        .then((response) => {
          this.gift = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      this.updateGift(this.gift)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
